import { Component } from 'react'
import moment from 'moment'
import { Button, Tip } from '@vzmi/shp_shared_compo'
import { DEFAULT_DASHBOARD_BESTSELLERS_DATE_RANGE, YESTERDAY } from '../../../../../constants/date'
import { getUIFormatDate, DATE_FORMAT } from '../../../../../lib/MomentHelper'
import DateHelper from '../../../../../lib/DateHelper'
import { RangePickerField } from '../../../../Common/Form'
import FormRow from '../../../../Common/NewDashboard/FormRow/FormRow'
import {
  formDecorator,
  Field
} from '../../../../Common/forms'
import styles from './SearchForm.css'
import { FIELD } from '../Bestseller'

export const CONFIG = {
  form: 'BESTSELLER_FORM'
}

class SearchForm extends Component {
  constructor (props) {
    super(props)
    /*
      資料查詢區塊
      僅接30天內之資料查詢
      起：兩年以前之日期不可選擇
      迄且現在是 12:00:00 以後：今天(含)以後之日期不可選擇
      迄且現在是 11:59:59 以前：前一天(含)以後之日期不可選擇
    */
    const {
      startMinDate
    } = DateHelper.getSaleStatDefaultPeriod()
    const [start, end] = DEFAULT_DASHBOARD_BESTSELLERS_DATE_RANGE
    this.state = {
      periodStartMinDate: startMinDate,
      periodEndMaxDate: YESTERDAY,
      periodStart: getUIFormatDate(start),
      periodEnd: getUIFormatDate(end)
    }
  }

  componentDidMount () {
    this.props.onFormInit(this.props)
  }

  onSubmit = (e) => {
    this.props.handleSubmit(e)
  }

  // 調整「起」的日期後，則「迄」跟著自動變動：
  // 「起」＋ㄧ個月 (30 天) ; 之後的日期 disable 不可選
  // 若「起」＋ㄧ個月 (30 天)  > 昨日，則為昨日
  // 若為購中店，則不得早於上線日期
  disabledDate = dateMoment => {
    const { isSeller, onlineDate } = this.props
    const {
      periodEndMaxDate,
      periodStartMinDate,
      periodStart
    } = this.state
    const oneMonthsLaterData = moment(periodStart).add(30, 'days')
    const todayData = moment()
    return (isSeller && onlineDate)
      ? dateMoment < moment(onlineDate, DATE_FORMAT.UI)
      : dateMoment < moment(periodStartMinDate) ||
    dateMoment >= (moment(oneMonthsLaterData).isBefore(todayData) ? oneMonthsLaterData : periodEndMaxDate)
  }

  onCalendarChange = dateMoment => {
    const periodStart = dateMoment[0].format('YYYY/MM/DD')
    this.setState({
      periodStart
    })
  }

  onMainRangeChange = (dateMoment, dateString) => {
    const [periodStart, periodEnd] = dateString
    this.setState({
      periodStart,
      periodEnd
    })
  }

  render () {
    const { customRange, tip, onlineDate } = this.props
    return (
      <form
        onSubmit={this.onSubmit}
        className={styles.searchForm}
      >
        <FormRow
          label='日期區間'
          labelAlign='center'
        >
          <Field
            key={FIELD.REPORT_DATE}
            name={FIELD.REPORT_DATE}
            data-role={FIELD.REPORT_DATE}
            className={styles.rangePicker}
            component={RangePickerField}
            defaultValue={customRange}
            onChange={this.onMainRangeChange}
            disabledDate={this.disabledDate}
            onCalendarChange={this.onCalendarChange}
          />
        </FormRow>
        <FormRow
          labelAlign='top'
          className={styles.tips}
        >
          <Tip type='info'>
            {
              tip ||
              `可查詢最早日期為${onlineDate || '兩年前'}，起迄區間最長為30天，每日中午更新`}
          </Tip>
        </FormRow>
        <FormRow labelAlign='top'>
          <Button
            type='submit'
            data-role='search-btn'
            size='large'
            className={styles.searchBtn}
          >
            查詢
          </Button>
        </FormRow>
      </form>
    )
  }
}

const SearchFormWithDecorator = formDecorator(CONFIG)(SearchForm)

export default SearchFormWithDecorator
